import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AudioFile } from '@model/audioFile';
import { Playlist } from '@model/playlist';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'tun-overlay-add-songs-to-playlist',
    templateUrl: './overlay-add-songs-to-playlist.component.html',
    styleUrl: './overlay-add-songs-to-playlist.component.scss',
    standalone: false
})
export class OverlayAddSongsToPlaylistComponent {

    @Input() tracks : AudioFile[] = [];

    @Output() close = new EventEmitter<boolean>();
    //@Output() closeWithPlaylist = new EventEmitter<Playlist>();

    get title(){
      return this.tracks && this.tracks.length > 1 ? this.translateService.instant('playlist.overlay.addTrack.multi.title').replace("{0}", this.tracks.length.toString()) : this.translateService.instant('playlist.overlay.addTrack.one.title');
    }

    constructor(
      private translateService: TranslateService,
    ) {
    }

    public onClose(){
      this.close.emit(false);
    }

    public onCloseWithPlaylist(playlist: Playlist){
      //todo: add tracks and show spinner
      this.close.emit(true);
    }

    public onSelectQueue(){

    }

    public onCreatePlaylist(){

    }


}
